import { Component } from '@angular/core';
import { PublicService } from './services/public.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'web';


  constructor(private pService : PublicService){
    /*
    this.pService.getMessage().subscribe(res => {
      console.log(res);
    });
    */
  }


}
